import { FETCH_ALL_VF_USERS_LIST } from "../../actions/actionTypes";

const initialState = {  
    data:[],
    loading: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {    
        case FETCH_ALL_VF_USERS_LIST.REQUEST:
            return {...state,loading: true}
        case FETCH_ALL_VF_USERS_LIST.FAILURE:
            return {...state, loading: false}
        case FETCH_ALL_VF_USERS_LIST.SUCCESS:             
            return {...state, data: action.obj.data, loading: false}    
        default:
            return state
    }
}

export default reducer;